export * from './gauge.module';
export { GaugeSegment } from './shared/gauge-segment';
export { GaugeLabel } from './shared/gauge-label';
